export const hybridspaceAdminDashboardLink = "PW_8vd";
export const hybridspaceManagementLink = "FmMcAb";
export const hybridspaceAnalyticsLink = "CNGMCd";
export default {hybridspaceAdminDashboardLink,hybridspaceManagementLink,hybridspaceAnalyticsLink};